/**
 * Collection
 */
import collectionFilters from '../lib/collection-filters';
import collectionPagination from '../lib/collection-pagination';
import collectionQuickview from '../lib/collection-quickview';
import collectionToolbar from '../lib/collection-toolbar';
import productItemApp from '../lib/product-item-app';
import comparePanel from '../lib/compare-panel';
import { shortlistAddTo } from '../lib/shortlist-add-to';
import collectionSortOptionsSort from '../lib/collection-sort-option-sort';
import uploadApp from '../lib/uploadApp';

// Collection Products
productItemApp({
  dom: {
    parent: 'collection',
  },
});

// Collection Toolbar
collectionToolbar();

// Collection Pagination
collectionPagination();

// Collection Filters
collectionFilters();

// Collection Quickview
collectionQuickview();

// Compare Panel Accordion
comparePanel();

// Shortlist Buttons
shortlistAddTo();

// Collection Sort Options Sort
collectionSortOptionsSort();

uploadApp();

// Collection Hero Tabs
const $collectionHeroTabs = document.querySelector('.tab');
if ($collectionHeroTabs) {
  const collectionHeroTabs = SDG.tabs({
    dom: {
      id: $collectionHeroTabs.id,
    },
  });
  collectionHeroTabs.init();
}
